<template>
  <div v-if="datas!==null" class="tFanshuiHistoryParentDiv" :style="{
    backgroundColor:HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white'
  }">
    <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;margin-bottom: 10px;">
      <HDatePicker :tag="tag" :smallType="true" style="margin-right: 6px;" onlySelectUI="true" :change="selectDateChange"/>
      <HRotateImg :clickImg="clickImg" width="21"/>
    </div>
    <div style="background: linear-gradient(to right,
          var(--ct-main-color) 0%,
          var(--ct-main-color) 10%,
          white 45%,
          white 50%,
          white 55%,
          var(--ct-main-color) 90%,
          var(--ct-main-color) 100%);
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          padding:5px;
          display: flex;flex-direction: column;justify-content: flex-end;align-items: center;">
      <div :style="hcf.getTextStyle({
            addSize:-1,color:HNewGameUIConfig.newGameUIType === 3?'#555':'',
        })">历史总领取返水金额</div>
      <div :style="hcf.getTextStyle({
          addSize:3,color:'main',fontWeight:'bold'
        })">{{datas["HistoryGetRebateAmount"]}}</div>
    </div>
    <div style="height:100%;flex:1;display: flex;flex-direction: column;">
      <div style="background-color: var(--ct-main-bg-color);">
        <HTable :tabData='{
          "header": ["返水时间", "返水金额", "派奖方式"],
          "list": datas["TableList"] ?? [],
        }'/>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HDatePicker from "@/components/utils/HDatePicker.vue";
  import HRotateImg from "@/components/utils/HRotateImg.vue";
  import HTable from "@/components/utils/HTable.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  defineProps(["tag"])

  const user = useUserStore();
  const http = useHHttp();
  const datas = ref({});

  const { nowSecs, nDaysAgoSecs } = hcf.getNowAndNDaysAgoStart();
  const requestStartSecs = ref(nDaysAgoSecs);
  const requestEndSecs = ref(nowSecs);

  function selectDateChange(startSecs, endSecs) {
    requestStartSecs.value = startSecs;
    requestEndSecs.value = endSecs;
    updateData();
  }

  function clickImg(){
    updateData();
  }
  function updateData(){
    http.request("/app/rebate/award/history", (resp)=>{
      datas.value = resp;
    },{
      params: {
        "BeginTime": requestStartSecs.value,
        "EndTime": requestEndSecs.value,
      }
    });
  }
  onMounted(()=>{
    updateData();
  });

</script>


<style scoped>

  .tFanshuiHistoryParentDiv {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    height:100%;
    position: relative;;
    padding: 10px 0;
  }

</style>
